import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/system/branch?page=1&maxData=99999999' // (17) 지사 조회

let swrData: any = getPersistData(KEY)

export function useBranchList() {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			try{
			const response = await API.get(KEY, token + '', {})
			swrData = response.result?.result?.list
			}catch(e){
				swrData = []
			}
			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		branchList: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}